import {
  EGNYTE_SOURCE_TYPE,
  algorithmRunStatuses,
  riskReliefDeviationRisks,
  riskReliefDeviationSeverities,
  workspaceDocumentSetStatuses,
  workspaceTypes,
} from '../../constants/constants'
import {
  AlgorithmRun,
  CAPAGeneration,
  NodeResults,
  RiskReliefDeviationClassification,
  RiskReliefDeviationClassificationGlobal,
  RiskReliefDeviationClassificationResult,
  RiskReliefDeviationClassificationRunResult,
  WorkspaceDetails,
} from '../../store/reducers/workspaceReducer'

const deviationClassificationGlobal: RiskReliefDeviationClassificationGlobal = {
  detectability: riskReliefDeviationSeverities.LOW,
  occurrence: riskReliefDeviationSeverities.MEDIUM,
  severity: riskReliefDeviationSeverities.HIGH,
  risk: riskReliefDeviationRisks.INCIDENT,
}

const deviationClassification: RiskReliefDeviationClassification = {
  id: '01',
  detectability: riskReliefDeviationSeverities.LOW,
  occurrence: riskReliefDeviationSeverities.MEDIUM,
  severity: riskReliefDeviationSeverities.HIGH,
  risk: riskReliefDeviationRisks.INCIDENT,
  identifiedRisk: 'Mocked data',
}

const deviationClassifications: RiskReliefDeviationClassification[] = [
  {
    ...deviationClassification,
  },
  {
    ...deviationClassification,
    id: '02',
    risk: riskReliefDeviationRisks.MINOR,
  },
  {
    ...deviationClassification,
    id: '03',
    risk: riskReliefDeviationRisks.MAJOR,
  },
  {
    ...deviationClassification,
    id: '04',
    risk: riskReliefDeviationRisks.CRITICAL,
  },
]

const rootCauses = {
  MockedCause: { count: 6, score: 1.5 },
  MockedCause2: { count: 5, score: 1.5 },
}

const capaItems: CAPAGeneration[] = [
  {
    id: '1',
    rootCause: 'Equipment',
    correctiveAction:
      'Technician performed routine maintenance on Refrigerator ABC, replacing faulty thermistor and ensuring proper calibration of temperature control system. Technician also re-checked and re-calibrated temperature sensors to ensure accuracy. Supervisor approved and implemented corrective action to prevent future occurrences.',
    preventiveAction:
      'Supervisor will schedule regular maintenance checks on Refrigerator ABC to ensure equipment is functioning properly and temperature control system is accurate. Additionally, Supervisor will review and update SOP 123 to include temperature control system calibration and maintenance procedures.',
  },
  {
    id: '2',
    rootCause: 'Design',
    correctiveAction:
      'Supervisor reviewed and updated SOP 123 to include temperature control system calibration and maintenance procedures. Supervisor also revised procedure to include proper sample handling and storage protocols, ensuring accurate results and regulatory compliance. Technician was re-trained on updated procedures.',
    preventiveAction:
      'Supervisor will review and update SOP 123 to include temperature control system calibration and maintenance procedures. Additionally, Supervisor will schedule regular training sessions for technicians to ensure they are familiar with updated procedures and protocols.',
  },
]

const resultRun: RiskReliefDeviationClassificationRunResult = {
  deviationClassification: deviationClassifications,
  deviationClassificationGlobal: deviationClassificationGlobal,
}

const deviationClassificationResult: RiskReliefDeviationClassificationResult = {
  deviationClassification: deviationClassifications,
  deviationClassificationGlobal: deviationClassificationGlobal,
}

const nodeResults: NodeResults = {
  DEVIATION_CLASSIFICATION: deviationClassificationResult,
  ROOT_CAUSE_DISCOVERY: rootCauses,
  CAPA_GENERATION: {
    capaGenerations: capaItems,
  },
}

const algorithmRunsArray: AlgorithmRun[] = [
  {
    id: '1',
    workspace: undefined,
    dataSource: undefined,
    runStatus: algorithmRunStatuses.ONGOING_AI,
    outputPath: 'string',
    runResult: resultRun,
    nodeResults: nodeResults,
    actionBy: undefined,
    actionDate: '2023-10-05T15:42:41.893Z',
    completedDate: '2023-10-05T15:42:41.893Z',
  },
  {
    id: '2',
    workspace: undefined,
    dataSource: undefined,
    runStatus: algorithmRunStatuses.COMPLETE,
    nodeResults: nodeResults,
    outputPath: 'string',
    runResult: undefined,
    actionBy: undefined,
    actionDate: '2023-10-05T15:42:41.893Z',
    completedDate: '2023-10-05T15:42:41.893Z',
  },
  {
    id: '3',
    workspace: undefined,
    dataSource: undefined,
    runStatus: algorithmRunStatuses.FAILED,
    nodeResults: nodeResults,
    outputPath: 'string',
    runResult: undefined,
    actionBy: undefined,
    actionDate: '2023-10-05T15:42:41.893Z',
    completedDate: '2023-10-05T15:42:41.893Z',
  },
  {
    id: '4',
    workspace: undefined,
    dataSource: undefined,
    runStatus: algorithmRunStatuses.READY,
    nodeResults: nodeResults,
    outputPath: 'string',
    runResult: undefined,
    actionBy: undefined,
    actionDate: '2023-10-05T15:42:41.893Z',
    completedDate: '2023-10-05T15:42:41.893Z',
  },
  {
    id: '5',
    workspace: undefined,
    dataSource: undefined,
    runStatus: algorithmRunStatuses.CANCELLED,
    nodeResults: nodeResults,
    outputPath: 'string',
    runResult: undefined,
    actionBy: undefined,
    actionDate: '2023-10-05T15:42:41.893Z',
    completedDate: '2023-10-05T15:42:41.893Z',
  },
]

const workspaceMock: WorkspaceDetails = {
  id: '51748',
  clusterId: null,
  externalId: null,
  title: 'Workspace title',
  description: 'Workspace desc',
  workspaceType: '45064',
  dataSource: {
    uiFlags: 1,
    id: '51744',
    clusterId: null,
    externalId: null,
    oid: null,
    sourceType: EGNYTE_SOURCE_TYPE,
    title: 'Ref Check DataSet',
    description: 'Ref Check DataSet',
    visibility: 'ORGANIZATION',
    organizationName: 'GenAIz',
    contactName: 'Amine Belaid',
    contactEmail: 'amine.belaid@genaiz.com',
    defaultSource: false,
    config: {
      tenantUid: 'cb391f85-989b-44e8-973d-6ec9c9cacef1',
      sourceFolder: 'RefAI Dataset',
      sourceFolderId:
        'netorg96863.sharepoint.com,cb2b3a66-268a-448e-8dcb-7970168cbd23,b55e3c2c-0539-408c-91eb-c179869a1608',
    },
    participants: [],
    createdBy: '63f79442930987a1621ef75a',
    lastModifiedBy: '63f79442930987a1621ef75a',
    createdDate: '2023-10-04T15:21:11.788Z',
    lastModifiedDate: '2023-10-04T15:21:11.788Z',
    typeName: 'SharePoint',
    typeCode: 'SP',
    isInternal: true,
    searchable: true,
  },
  algorithmRuns: algorithmRunsArray,
  createdBy: '63f79442930987a1621ef75a',
  lastModifiedBy: '63f79442930987a1621ef75a',
  createdDate: '2023-10-05T15:42:41.893Z',
  lastModifiedDate: '2023-10-05T15:42:41.893Z',
  participants: [],
  visibility: 'ORGANIZATION',
  typeName: 'Assets Merger & Acquisition',
  typeCode: workspaceTypes.RISK_REL,
  algorithmName: 'Risk Relief',
  config: {
    riskReliefConfig: {
      searchReviewIds: ['1'],
      queryDeviations: [
        {
          searchReviewId: '1',
          searchQueryId: '01',
          deviationStatus: workspaceDocumentSetStatuses.OPENED,
        },
        {
          searchReviewId: '1',
          searchQueryId: '02',
          deviationStatus: workspaceDocumentSetStatuses.CLOSED,
        },
      ],
      deviations: [
        {
          searchResultId: '1',
          searchReviewId: '1',
          searchQueryId: '01',
          urn: '',
          deviationStatus: workspaceDocumentSetStatuses.OPENED,
        },
        {
          searchResultId: '2',
          searchReviewId: '1',
          searchQueryId: '02',
          urn: '',
          deviationStatus: workspaceDocumentSetStatuses.CLOSED,
        },
      ],
    },
  },
}

export default workspaceMock
